import { Box, Container, Typography, Link as MuiLink, Grid, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import MapIcon from '@mui/icons-material/Map';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: 'grey.900',
                color: 'grey.300',
                py: 6,
                mt: 'auto',
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {/* Brand */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                            <Box
                                sx={{
                                    width: 36,
                                    height: 36,
                                    borderRadius: 2,
                                    background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <MapIcon sx={{ color: 'white', fontSize: 20 }} />
                            </Box>
                            <Typography variant="h6" sx={{ color: 'white', fontWeight: 700 }}>
                                GIS Analysis
                            </Typography>
                        </Box>
                        <Typography variant="body2" sx={{ mb: 2, maxWidth: 300 }}>
                            Automated GIS spatial analysis solution. Upload your spatial files and get professional PDF reports in minutes.
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <IconButton
                                size="small"
                                sx={{ color: 'grey.400', '&:hover': { color: 'primary.main' } }}
                                aria-label="GitHub"
                            >
                                <GitHubIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                                size="small"
                                sx={{ color: 'grey.400', '&:hover': { color: 'primary.main' } }}
                                aria-label="LinkedIn"
                            >
                                <LinkedInIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                                size="small"
                                sx={{ color: 'grey.400', '&:hover': { color: 'primary.main' } }}
                                aria-label="Email"
                            >
                                <EmailIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Grid>

                    {/* Quick Links */}
                    <Grid item xs={6} md={2}>
                        <Typography variant="subtitle2" sx={{ color: 'white', fontWeight: 600, mb: 2 }}>
                            Menu
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <MuiLink
                                component={Link}
                                to="/"
                                sx={{
                                    color: 'grey.400',
                                    textDecoration: 'none',
                                    '&:hover': { color: 'primary.main' },
                                }}
                            >
                                Home
                            </MuiLink>
                            <MuiLink
                                component={Link}
                                to="/upload"
                                sx={{
                                    color: 'grey.400',
                                    textDecoration: 'none',
                                    '&:hover': { color: 'primary.main' },
                                }}
                            >
                                Upload File
                            </MuiLink>
                        </Box>
                    </Grid>

                    {/* Formats */}
                    <Grid item xs={6} md={2}>
                        <Typography variant="subtitle2" sx={{ color: 'white', fontWeight: 600, mb: 2 }}>
                            Supported Formats
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography variant="body2" sx={{ color: 'grey.400' }}>
                                Shapefile (.shp)
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'grey.400' }}>
                                ZIP Archive (.zip)
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'grey.400' }}>
                                GeoPackage (.gpkg)
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Contact */}
                    <Grid item xs={12} md={4}>
                        <Typography variant="subtitle2" sx={{ color: 'white', fontWeight: 600, mb: 2 }}>
                            Contact
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'grey.400', mb: 1 }}>
                            Have questions? Contact us.
                        </Typography>
                        <MuiLink
                            href="mailto:support@gisanalysis.com"
                            sx={{
                                color: 'primary.main',
                                textDecoration: 'none',
                                '&:hover': { textDecoration: 'underline' },
                            }}
                        >
                            support@gisanalysis.com
                        </MuiLink>
                    </Grid>
                </Grid>

                {/* Bottom */}
                <Box
                    sx={{
                        mt: 6,
                        pt: 3,
                        borderTop: '1px solid',
                        borderColor: 'grey.800',
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 2,
                    }}
                >
                    <Typography variant="caption" sx={{ color: 'grey.500' }}>
                        © {currentYear} GIS Analysis. All rights reserved.
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 3 }}>
                        <MuiLink
                            href="#"
                            sx={{
                                color: 'grey.500',
                                textDecoration: 'none',
                                fontSize: '0.75rem',
                                '&:hover': { color: 'grey.300' },
                            }}
                        >
                            Privacy Policy
                        </MuiLink>
                        <MuiLink
                            href="#"
                            sx={{
                                color: 'grey.500',
                                textDecoration: 'none',
                                fontSize: '0.75rem',
                                '&:hover': { color: 'grey.300' },
                            }}
                        >
                            Terms of Service
                        </MuiLink>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
